var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6.74003 3.16602C6.6867 3.36602 6.66671 3.58602 6.66671 3.83268V5.83268H3.33337V4.49935C3.33337 3.76602 3.93337 3.16602 4.66671 3.16602H6.74003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 13.1673V5.83398H3.33337C2.00004 5.83398 1.33337 6.50065 1.33337 7.83398V13.1673C1.33337 14.5007 2.00004 15.1673 3.33337 15.1673H8.66671C7.33337 15.1673 6.66671 14.5007 6.66671 13.1673ZM4.50004 11.834C4.50004 12.1073 4.27337 12.334 4.00004 12.334C3.72671 12.334 3.50004 12.1073 3.50004 11.834V9.16732C3.50004 8.89398 3.72671 8.66732 4.00004 8.66732C4.27337 8.66732 4.50004 8.89398 4.50004 9.16732V11.834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.33329 15.1673H8.66663C7.33329 15.1673 6.66663 14.5007 6.66663 13.1673V3.83398C6.66663 2.50065 7.33329 1.83398 8.66663 1.83398H12.6666C14 1.83398 14.6666 2.50065 14.6666 3.83398V13.1673C14.6666 14.5007 14 15.1673 12.6666 15.1673H12",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5007V15.1673H9.33337V12.5007C9.33337 12.134 9.63337 11.834 10 11.834H11.3334C11.7 11.834 12 12.134 12 12.5007Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 9.66732C9.06004 9.66732 8.83337 9.44065 8.83337 9.16732V5.83398C8.83337 5.56065 9.06004 5.33398 9.33337 5.33398C9.60671 5.33398 9.83337 5.56065 9.83337 5.83398V9.16732C9.83337 9.44065 9.60671 9.66732 9.33337 9.66732Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.66732C11.7267 9.66732 11.5 9.44065 11.5 9.16732V5.83398C11.5 5.56065 11.7267 5.33398 12 5.33398C12.2733 5.33398 12.5 5.56065 12.5 5.83398V9.16732C12.5 9.44065 12.2733 9.66732 12 9.66732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.8e3c5ef378c4b318a2f37b56f1569f8e.svg";
export { ForwardRef as ReactComponent };